export const formatBalance = (value) => {
    if (typeof value === 'number') {
        const parts = value.toString().split('.');
        if (parts.length > 1) {
            return `${parts[0]}.${parts[1].charAt(0)}`;
        }
        return parts[0];
    }
    return value;
};